export default __webpack_public_path__ + "static/media/sustainable.cfb95471.png";